module.exports = ".ribbon-content{position:relative;min-height:40px}.ribbon-content .content{position:absolute;left:0;right:0;top:0;bottom:0;color:white}.ribbon-content .content .label{font-weight:bold}.ribbon-content .background{position:absolute;left:0;right:0;bottom:0;top:0;background-color:#000;opacity:0.4;border:1px solid #1f1f1f}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ui/ribbon-message/ribbon-message.component.scss
// module id = 633
// module chunks = 0